import { Pipe, PipeTransform } from '@angular/core';
import type { CardsThatLayoutOntoPaper } from '../../../models/menu/section/cards-that-layout-onto-paper';

@Pipe({
  name: 'cardPreviewHeightInPx',
  standalone: false
})
export class CardPreviewHeightInPxPipe implements PipeTransform {
  transform(cardsThatLayoutOntoPaper: CardsThatLayoutOntoPaper | null): number {
    return cardsThatLayoutOntoPaper?.cardPreviewHeightInPx() ?? 0;
  }
}
